<template>
  <div :class="$style['super-base-engagement-tool']">
    <engagement-layout source="basicscreen">
      <template #heading>{{ pageHeadingInfo.heading }} </template>
      <!-- <template #info-tooltip>{{ pageHeadingInfo.headingIconText }} </template> -->
      <template #sub-heading>{{ pageHeadingInfo.subHeading }}</template>

      <template #left-side-bar>
        <div :class="$style['left-body-container']">
          <adl-expandable-card
            :data="expandableCardData"
            @OnChange="ChangeExpandableCard"
            @edit="EditCard"
            @refresh="refresh"
          >
          </adl-expandable-card>
          <div :class="$style['engagement-form']">
            <adl-expandable-eloqua-form
              :loading="loading"
              :tabs="formModel.tabs"
              :sections="formModel.sections"
              :sectionElements="formModel.sectionElements"
              :elements="formModel.elements"
              :formSubmitElements="formSubmitElements"
              @formChange="formChange"
              @dropDownChange="dropDownChange"
              @submit="onSubmit"
              @EditDataList="EditDataList"
            >
              <template v-slot:outsideGroup>
                <slot name="expandableformdata"></slot>
              </template>
              <template v-slot:tooltipText>
                <slot name="tooltipText"></slot>
              </template>
            </adl-expandable-eloqua-form>
          </div>
          <div :class="[$style['cfSet'], $style['relatedGoalsWrapper']]">
            <link-goal :linkGoalInfo="linkGoalInfo"></link-goal>
          </div>
        </div>
      </template>

      <template #right-side-bar>
        <div
          v-if="!isShowEmptyState"
          class="right-body-container right-body-white-container"
        >
          <div :class="$style['graph-selection-view']">
            <graph-selection
              :buttonDataTypeConfig="buttonDataTypeConfig"
              :buttonViewTypeConfig="buttonViewTypeConfig"
              @onSelectDataTypeFilter="onSelectDataTypeFilter"
              @onSelectViewTypeFilter="onSelectViewTypeFilter"
            ></graph-selection>
          </div>
          <chart-selection
            :chartTabContent="chartTabContent"
            :height="390"
            @onSelectedTab="onSuperSelectedTab"
          >
            <template v-slot:right-side-section>
              <div v-if="isShowDownloadIcon">
                <mds-button
                  variation="secondary"
                  :class="$style['upload-link-label']"
                  @click="toggleReportOption = !toggleReportOption"
                  icon="document"
                  id="reportType"
                  type="button"
                >
                  Create Report
                </mds-button>
                <mds-popover
                  width="200px"
                  v-if="toggleReportOption"
                  triggered-by="reportType"
                  v-model="toggleReportOption"
                  :position="['bottom-right']"
                >
                  <ul class="report-container">
                    <li
                      class="upload-link-list"
                      v-for="key in downloadOption"
                      :key="key.value"
                    >
                      <div class="upload-link-container">
                        <img :src="key.iconPath" class="report-icon" />
                        <span
                          href="#"
                          v-on:click="downloadExcelFile(key.value)"
                          class="upload-link"
                          >{{ key.text }}</span
                        >
                      </div>
                    </li>
                  </ul>
                </mds-popover>
              </div>
              <adl-input-format
                :label="'Projection Year'"
                :class="$style['projectionPosition']"
                size="small"
                :value="0"
                v-model="projectionYear.Value"
                appendText=""
                :maxlength="3"
                :maxvalue="projectionYear.Maxvalue"
                :isAllowOnlyNumber="true"
                :isAllowOnlyInteger="true"
                currencyFormat=""
                :isError="projectionYear.IsError"
                :errorText="projectionYear.ErrorText"
                @change="changeSuperProjectionYear($event)"
                @submit="submitSuperProjectionYear($event)"
              ></adl-input-format>
            </template>
            <template v-slot:tabBody>
              <component
                :is="selectedComponent"
                :chartProperties="chartProperties"
                :chartData="chartData"
                :linePlotData="linePlotData"
                v-if="chartData.length > 0"
                :TableSettings="tableViewSettings"
                :ShowTableView="showTableView"
              ></component>
            </template>
          </chart-selection>
          <summary-block
            v-if="!showTableView"
            :leftToolSummary="leftToolSummary"
            :rightToolSummary="rightToolSummary"
          ></summary-block>
        </div>
        <div
          class="right-body-container right-body-white-container emptychartbox"
          :class="$style['empty-container']"
          v-else
        >
          <div class="emptychartboxicon">
            <!-- <mds-icon name="ip-super-sector-sensitive"></mds-icon> -->

            <img alt="nochart" src="../../assets/no-chart-data.svg" />
          </div>
          <div class="emptychartboxpadding">
            {{ emptyChartMessage.message }}
          </div>
        </div>
      </template>

      <template #footer>
        <page-footer>
          <template #action-button-left>
            <mds-button
              size="large"
              variation="flat"
              icon="caret-left"
              @click="onBackButtonClick"
            >
              Back
            </mds-button>
          </template>
          <template #action-button-right>
            <mds-button
              type="button"
              variation="secondary"
              @click="cancelButtonClick"
            >
              Cancel
            </mds-button>
            <mds-button
              type="button"
              variation="primary"
              @click="saveButtonClick"
            >
              Save
            </mds-button>
          </template>
        </page-footer>
      </template>
    </engagement-layout>
  </div>
</template>

<script>
import { EngagementLayout } from "../../component";
import GraphSelection from "../tool/graph-selection.vue";

import { PageFooter } from "../../component";
import AdlExpandableEloquaForm from "../custom/eloqua-expandable-form/ExpandableEloquaForm.vue";
import { ChartArea, ChartBar } from "../tool";
import { MdsTabs, MdsTabsItem } from "@mds/tabs";
import { LinkGoal, SummaryBlock, ChartSelection } from "../../component/tool";
import { MdsButton } from "@mds/button";
import AdlCardDropdown from "../custom/CardDropdown/CardDropdown.vue";
import AdlInputFormat from "../custom/input-format/InputFormat.vue";
import AdlExpandableCard from "../custom/expandable-card/ExpandableCard.vue";
import MdsPopover from "@mds/popover";

export default {
  props: {
    pageHeadingInfo: {
      type: Object,
    },
    linkGoalInfo: {
      type: Object,
    },
    leftToolSummary: {
      type: Array,
    },
    rightToolSummary: {
      type: Array,
    },
    downloadOption: {
      type: Array,
    },
    downloadLabelName: {
      type: String,
    },
    formModel: {
      type: Object,
    },
    formSubmitElements: {
      type: Array,
    },
    chartTabContent: {
      type: Array,
    },

    chartProperties: {
      type: Object,
    },
    chartData: {
      type: Array,
    },
    linePlotData: {
      type: Array,
    },
    selectedComponent: {
      type: String,
    },
    projectionYear: {
      type: Object,
    },
    isShowEmptyState: {
      type: Boolean,
    },
    emptyChartMessage: {
      type: Object,
    },
    expandableCardData: {
      type: Object,
    },
    isShowDownloadIcon: {
      type: Boolean,
    },
    showTableView: {
      type: Boolean,
      default: false,
    },
    tableViewSettings: {
      type: Object,
    },
    buttonDataTypeConfig: {
      type: Array,
    },
    buttonViewTypeConfig: {
      type: Array,
    },
  },
  components: {
    AdlCardDropdown,
    MdsButton,
    ChartArea,
    ChartBar,
    MdsPopover,
    ChartSelection,
    EngagementLayout,
    LinkGoal,
    SummaryBlock,
    AdlExpandableEloquaForm,
    PageFooter,
    MdsTabs,
    MdsTabsItem,
    AdlInputFormat,
    AdlExpandableCard,
    GraphSelection,
  },
  data() {
    return {
      showdropdown: true,
      loading: false,
      toggleReportOption: false,
      cancelButtonToggle: false,
      saveButtonToggle: true,
      backButtonToggle: false,
    };
  },
  computed: {},

  methods: {
    onSelectDataTypeFilter(button, item, filterType) {
      this.$emit("onSelectDataTypeFilter", button, item, filterType);
    },

    onSelectViewTypeFilter(button, item, filterType) {
      this.$emit("onSelectViewTypeFilter", button, item, filterType);
    },
    refresh(data) {
      this.$emit("refresh", data);
    },
    EditDataList(data) {
      this.$emit("EditDataList", data);
    },
    onSubmit(callBackMethod) {
      this.$emit("onSubmit", callBackMethod);
    },
    EditCard(data) {
      this.$emit("EditCard", data);
    },
    ChangeExpandableCard(data) {
      this.$emit("ChangeExpandableCard", data);
    },
    dropDownChange(callBackMethod, data, elementIndex) {
      this.$emit("dropDownChange", callBackMethod, data, elementIndex);
    },
    cancelButtonClick() {
      this.$emit("cancelInstance", {});
    },
    saveButtonClick() {
      this.$emit("saveInstance", {});
    },
    onBackButtonClick() {
      this.$emit("onBack", {});
    },
    onSuperSelectedTab(tabId) {
      this.$emit("onChangeChartTab", tabId);
    },
    formChange(form) {
      this.$emit("formChange", form);
    },
    changeSuperProjectionYear(data) {
      this.$emit("changeSuperProjectionYear", data);
    },
    downloadExcelFile(fileType) {
      this.$emit("downloadExcelFile", fileType);
    },
    submitSuperProjectionYear() {
      this.$emit("onSubmit", "reloadSuperGraph");
    },
  },
};
</script>

<style lang="scss" module>
@import "@mds/link";
.super-base-engagement-tool {
  .upload-link {
    @include mds-link();
    color: $mds-interactive-color-primary-default !important;
    float: right;
    margin-top: 30px;
    font-size: 14px;
    line-height: 16px;
    border-bottom: 1px solid $mds-interactive-color-primary-default;
    cursor: pointer;
  }
  .upload-link-label {
    margin-right: 120px;

    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 21px;
  }
  .empty-container {
    margin-top: 5px;
  }
  .cfSet {
    width: 100%;
    float: left;
  }
  .projectionPosition {
    position: absolute;
    top: -7px;
    right: 0;
    width: 110px;
    .mds-input__field-error-wrapper {
      position: absolute;
      right: 0;
    }
  }
  .left-body-container {
    .engagement-form {
      margin-top: $mds-space-2-x;
      margin-bottom: $mds-space-3-x;
    }
    .relatedGoalsWrapper {
      .mds-section--tertiary {
        padding-top: $mds-space-2-x;
      }
    }
  }
}
</style>
